document.addEventListener('DOMContentLoaded', function () {
  AOS.init({
    duration: 1000,
    once: true,
    mirror: false,
    easing: 'ease-out-quad',
    offset: 120,
    anchorPlacement: 'top-bottom'
  });
});
